import { Link } from 'react-router-dom'
import { PLATFORMS, STUDENT_JOURNEY } from '@/data/siteData'
import SectionHeader from '@/components/SectionHeader/SectionHeader'
import styles from './EcosystemSection.module.css'

export default function EcosystemSection() {
  return (
    <section id="ecosystem" className={styles.section} aria-label="NexusAI Ecosystem">
      <div className={styles.grid}>
        {/* Left */}
        <div>
          <SectionHeader
            label="Our Platforms"
            title={'Three platforms,\none identity.'}
            desc="Single login. One account. Access SkillNexus, InternNexus, and PromptNexus — switch seamlessly from the product switcher."
          />

          <div className={styles.items}>
            {PLATFORMS.map(p => (
              <Link to={`/${p.id}`} key={p.id} className="eco-item" style={{ textDecoration: 'none' }}>
                <div
                  className={styles.itemIcon}
                  style={{ background: p.colorBg, color: p.color }}
                >
                  {p.abbr}
                </div>
                <div>
                  <p className={styles.itemName}>{p.name}</p>
                  <p className={styles.itemDesc}>{p.ecoDesc}</p>
                </div>
              </Link>
            ))}
            <div className={styles.comingSoon}>
              <p>More platforms coming soon &nbsp;🚀</p>
            </div>
          </div>
        </div>

        {/* Right — Journey */}
        <div className={styles.journeyCard}>
          <p className={styles.journeyLabel}>The Student Journey</p>
          {STUDENT_JOURNEY.map((step, i) => (
            <div
              key={step.num}
              className={styles.flowRow}
              style={{ borderBottom: i < STUDENT_JOURNEY.length - 1 ? '1px solid var(--border)' : 'none' }}
            >
              <div
                className={styles.flowNum}
                style={{ background: step.bg, color: step.color }}
              >
                {step.num}
              </div>
              <p className={styles.flowName}>{step.name}</p>
              <p className={styles.flowDesc}>{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
